const DURATION_TYPE_MOUNTH = 3;
const DURATION_TYPE_DAY = 2;
const DAY_HOUR = 8;

export {
    DURATION_TYPE_MOUNTH,
    DURATION_TYPE_DAY,
    DAY_HOUR
};